import React, { useRef, useEffect, useState } from "react";
import Cookies from "js-cookie";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import "../css/Calendarcss.css";
import { CmsService } from "../services/cmsService";

function Calendar() {
  const divRef = useRef(null);
  const [savedLanguage] = useState(Cookies.get("language"));
  const [events, setEvents] = useState([]);

  useEffect(() => {
    var cmsService = new CmsService();
    cmsService
      .retrieveEvents(0, 40)
      .then((value) => {
        return value.data;
      })
      .then((value) => {
        // Assuming value.data.tcmsEventCalendarList is an array of events
        const eventsData = value.tcmsEventCalendarList.map((event) => {
          return {
            title:
              savedLanguage === "en"
                ? event.calendarNameEng
                : savedLanguage === "hk"
                  ? event.calendarNameHk
                  : event.calendarNameCn,
            start: event.startDate,
            end: new Date(event.endDate),
          };
        });
        setEvents(eventsData);
      })
      .catch((error) => {
        console.error("Error retrieving events:", error);
      });
  }, [savedLanguage]);

  useEffect(() => {
    const divElement = divRef.current;
    const calendarElement = divElement?.querySelector(".fc");
    if (calendarElement) {
      const handleResize = () => {
        const rect = divElement.getBoundingClientRect();
        calendarElement.style.width = rect.width + "px";
        calendarElement.style.height = rect.height + "px";
      };

      handleResize();

      window.addEventListener("resize", handleResize);
      return () => {
        window.removeEventListener("resize", handleResize);
      };
    }
  }, []);

  // Function to customize the rendering of events
  function eventContent(eventInfo) {
    return (
      <div className="fc-content">
        <span className="fc-title">{eventInfo.event.title}</span>
      </div>
    );
  }

  // Function to customize the rendering of day cell content
  function dayCellContent({ date, dayNumberText }) {
    return (
      <>
        <span className="fc-day-number" style={{ color: "#004846" }}>
          {dayNumberText}
        </span>
      </>
    );
  }

  const customCss = `
  .fc .fc-col-header-cell-cushion{
      --bs-link-color: #009188;
      --bs-link-hover-color: #009188;
      
    }

    .fc-toolbar-title{
      color: #4f575e;
    }

    .fc .fc-button-primary {
      background-color: #009188;
      border-color: #009188;
      color: var(--fc-button-text-color);
      --fc-button-hover-bg-color: #004846;
     --fc-button-hover-border-color: #004846;
     --fc-button-active-bg-color: #004846;
    --fc-button-active-border-color:#004846 ;
  }
  `;

  return (
    <div
      id="calendar-container"
      className="w-5/6 text-landingContent"
      ref={divRef}>
      <style>{customCss}</style>
      <FullCalendar
        plugins={[dayGridPlugin]}
        initialView="dayGridMonth"
        eventContent={eventContent}
        dayCellContent={dayCellContent}
        eventTextColor="white"
        events={events}
        eventBackgroundColor="#009188"
        eventBorderColor="#004846"
        height="md:auto"
      />
    </div>
  );
}

export default Calendar;
